import { useContext } from 'react';

import { LayoutHeaderDefaultSearchTypeContext } from '#/layouts/Layout/Header/LayoutHeaderDefaultSearchTypeContext';
import { DynamicSearchEventsRefinements } from '#/modules/search/events/components/Refinements/DynamicSearchEventsRefinements';
import { DynamicSearchGroupsRefinements } from '#/modules/search/groups/components/Refinements/DynamicSearchGroupsRefinements';
import { DynamicSearchInternshipRefinements } from '#/modules/search/internships/components/Refinements/DynamicSearchInternshipRefinements';
import { DynamicSearchJobsRefinements } from '#/modules/search/jobs/components/Refinements/DynamicSearchJobsRefinements';
import { DynamicSearchOrgsRefinements } from '#/modules/search/orgs/components/Refinements/DynamicSearchOrgsRefinements';
import { DynamicSearchVolopsRefinements } from '#/modules/search/volops/components/Refinements/DynamicSearchVolopsRefinements';

import type { SearchRefinementsLayout } from './SearchRefinements';

type Args = {
  variant?: SearchRefinementsLayout;
};

/**
 * Ideally we should get rid of this component and reference the refinements
 * we need directly, but we need it in the SearchLandingPage
 */
export function SearchRefinementsSwitch({ variant }: Args) {
  const searchType = useContext(LayoutHeaderDefaultSearchTypeContext);

  switch (searchType) {
    case 'JOB':
      return <DynamicSearchJobsRefinements layoutVariant={variant} />;
    case 'INTERNSHIP':
      return <DynamicSearchInternshipRefinements layoutVariant={variant} />;
    case 'VOLOP':
      return (
        <DynamicSearchVolopsRefinements
          includeSourcesFacet={false}
          layoutVariant={variant}
        />
      );
    case 'ORG':
      return <DynamicSearchOrgsRefinements layoutVariant={variant} />;
    case 'GROUP':
      return <DynamicSearchGroupsRefinements layoutVariant={variant} />;
    case 'EVENT':
      return <DynamicSearchEventsRefinements layoutVariant={variant} />;
  }
}
